<div class="alert alert-info">
  <p>
    <strong>Note:</strong> This task was rejected during quality review of a
    larger group of tasks. Please review the answers and make changes if needed.
    Contact your team lead if you have any questions.
  </p>
  <p *ngIf="singleReason$ | async">
    <strong>Reason:</strong> {{ singleReason$ | async }}
  </p>
  <ng-container *ngIf="multipleReasons$ | async">
    <p>
      <strong>Reasons:</strong>
    </p>
    <ul>
      <li *ngFor="let reason of multipleReasons$ | async">{{ reason }}</li>
    </ul>
  </ng-container>
</div>
